import { useEffect, useState } from 'react';

import { useQuery } from '@tanstack/react-query';
import { isEqual } from 'lodash';
import Api, { withAcl } from 'hooks/Api';
import { useProvider } from 'utils/providers/Provider';
import { GmailThread } from 'utils/types';
import { useAdminParams } from 'utils/helpers';

import c from '../../utils/constants';

export default function useGetGmailThread(id?: string, q = {}) {
  const { state } = useProvider();
  const { accountId, accountUserId } = useAdminParams();
  const args = state;

  const [params, setParams] = useState<Record<string, any>>(q);

  useEffect(() => {
    if (!isEqual(q, params)) {
      setParams(q);
    }
  }, [params, q]);

  return useQuery<GmailThread, Error>({
    queryKey: [c.GMAIL_THREADS, id, params],
    queryFn: async () => {
      const api = new Api(args);

      const data = await api.get(
        await withAcl({
          account: {
            url: `api/v1/channels/google/mail/threads/${id}`,
            params,
            transformer: (res: any) => res,
          },
          admin: {
            // eslint-disable-next-line max-len
            url: `api/v2/accounts/${accountId}/users/${accountUserId}/channels/google/mail/threads/${id}`,
            params,
            transformer: (res: any) => res,
          },
        }),
      );

      return data?.data;
    },
    enabled: !!id && !!params.from,
  });
}
